import { render, staticRenderFns } from "./GlyphCustomizationSlidingWindow.vue?vue&type=template&id=1aab07c3&scoped=true"
import script from "./GlyphCustomizationSlidingWindow.vue?vue&type=script&lang=js"
export * from "./GlyphCustomizationSlidingWindow.vue?vue&type=script&lang=js"
import style0 from "./GlyphCustomizationSlidingWindow.vue?vue&type=style&index=0&id=1aab07c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab07c3",
  null
  
)

export default component.exports